const SkyShader = {
  uniforms: {
    skyTime: { value: 7.0 },
    skyOpacity: { value: 1.0 },
  },
  vertexShader: `varying highp vec2 vUv;
  void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }`,
  fragmentShader: `
  uniform float skyTime;
  uniform float skyOpacity;

  varying vec2 vUv;
  
  vec4 midnightColor = vec4(0.0602, 0.0919, 0.2500, 0.6); // 午夜0.05, 0.05, 0.15
  vec4 dawnColor = vec4(0.4005, 0.5432, 0.8510, 0.8);        // 凌晨0.3, 0.4, 0.6
  vec4 morningColor = vec4(0.4416, 0.7050, 1.0000, 0.7);     // 早晨0.5, 0.7, 1.0
  vec4 noonColor = vec4(0.5842, 0.7033, 1.0000, 0.6);        // 中午0.3, 0.6, 1.0
  vec4 afternoonColor = vec4(0.3844, 0.6402, 1.0000, 0.6);   // 下午
  vec4 duskColor = vec4(0.7050, 0.4721, 0.5914, 0.6);        // 黄昏
  vec4 eveningColor = vec4(0.5983, 0.3761, 0.4871, 0.7);     // 傍晚
  vec4 nightColor = vec4(0.0947, 0.0947, 0.1500, 0.6);       // 夜晚
  
  // sRGB到线性空间的转换函数
  vec3 sRGBToLinear(vec3 srgb) {
      return pow(srgb, vec3(2.2));
  }

  vec4 getSkyColor(float time) {
      vec4 timeColor;
      if (time < 3.0) {
          // 午夜到凌晨
          timeColor = mix(midnightColor, dawnColor, time / 3.0);
      } else if (time < 6.0) {
          // 凌晨到早晨
          timeColor = mix(dawnColor, morningColor, (time - 3.0) / 3.0);
      } else if (time < 9.0) {
          // 早晨到中午
          timeColor = mix(morningColor, noonColor, (time - 6.0) / 3.0);
      } else if (time < 15.0) {
          // 中午到下午
          timeColor = mix(noonColor, afternoonColor, (time - 9.0) / 6.0);
      } else if (time < 18.0) {
          // 下午到黄昏
          timeColor = mix(afternoonColor, duskColor, (time - 15.0) / 3.0);
      } else if (time < 19.5) {
          // 黄昏到傍晚
          timeColor = mix(duskColor, eveningColor, (time - 18.0) / 1.5);
      } else if (time < 21.0) {
          // 傍晚到夜晚
          timeColor = mix(eveningColor, nightColor, (time - 19.5) / 1.5);
      } else {
          // 夜晚到午夜
          timeColor = mix(nightColor, midnightColor, (time - 21.0) / 3.0);
      }
      return timeColor;
  }

  float distanceTo(vec2 src, vec2 dst) {
      float dx = src.x - dst.x;
      float dy = src.y - dst.y;
      float dv = dx * dx + dy * dy;
      return sqrt(dv);
  }
  void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    //   vec4 skyColor1 = vec4(.086, .298, .458, 1.);///2d5a7c,.176,.352,.486,,164c75
    //   vec4 skyColor2 = vec4(.711, .849, .903, 1.);///9cbfcd,.611,.749,.803
      vec4 skyColor1 = vec4(0., 0., 0., 1.);///2d5a7c,.176,.352,.486,,164c75
     vec4 skyColor2 = vec4(.95, .95, .95, 1.);///9cbfcd,.611,.749,.803
  
      float sphere1 = (pow(distanceTo(vec2(0.5, 0.5), vUv), 2.8)+0.2) * 2.8;
  
      fragColor = skyColor1;
      vec4 timeColor = getSkyColor(skyTime);
     // vec4 color = mix(skyColor1, skyColor2, sphere1)*timeColor;
     float sphere1_clamp = clamp(sphere1, 0.0, 1.0);
      vec3 color = vec3(sphere1)*timeColor.rgb;

    //   fragColor=vec4(color,timeColor.a) ;
      // 将颜色转换到线性空间以补偿OutputPass的sRGB转换
      color = sRGBToLinear(color);
      fragColor=vec4((color+vec3(0.05))*1.2,0.97) ;
  
  }
  
  void main() {
      vec2 fragCoord = gl_FragCoord.xy;
      mainImage(gl_FragColor, fragCoord);
  }`,
}

export default SkyShader